import React from 'react';
import { Modal } from 'react-bootstrap';
import OrderEdit from './orderEdit/OrderEdit';
import type { Org } from '../../api/schemas/OrgSchema';

interface OrderModalProps {
  show: boolean;
  toggle: () => void;
  orderUuid: string;
  orgs: Org[];
}

export const OrderModal = ({
  show,
  toggle,
  orderUuid,
  orgs,
}: OrderModalProps) => {
  const handleClose = () => {
    toggle();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="queue-viewer-order-modal"
      dialogClassName="order-modal"
    >
      <OrderEdit orderUuid={orderUuid} close={handleClose} orgs={orgs} />
    </Modal>
  );
};
